import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cuándo recibo el ebook?',
    a: 'Al instante. Después del pago te llega el link de descarga por mail y podés abrirlo desde el celular en segundos.'
  }, {
    q: '¿Funciona con mi freidora?',
    a: 'Sí. Las recetas funcionan con cualquier marca y modelo de air fryer. No importa el tamaño ni la potencia.'
  }, {
    q: '¿Necesito saber cocinar para usarlo?',
    a: 'No. Ese es exactamente el punto. El ebook está diseñado para personas sin experiencia. Cada receta explica todo desde cero, con cantidades exactas y tiempos precisos.'
  }, {
    q: '¿Los ingredientes son fáciles de conseguir?',
    a: 'Sí, todos son ingredientes comunes que encontrás en cualquier supermercado o verdulería. Nada raro ni importado.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tenés 5 días de garantía total. Si sentís que no era lo que esperabas, te devolvemos el dinero sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-37">
      <div className="max-w-3xl mx-auto" data-id="element-38">
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-darkGray text-center mb-12" data-id="element-39">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-40">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-41">
              <button className="w-full py-5 px-6 text-left flex justify-between items-center focus:outline-none group" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-42">
                <span className="font-bold text-brand-darkGray text-lg pr-4 group-hover:text-brand-purple transition-colors" data-id="element-43">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-brand-purple transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-44" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 pb-5 px-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-45">
                <p className="text-brand-mediumGray font-medium leading-relaxed" data-id="element-46">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}